var map = {
	"./体检01.png": 2447,
	"./体检02.png": 2448,
	"./体检03.png": 2449,
	"./体检04.png": 2450,
	"./体检05.png": 2451,
	"./卡01.png": 2452,
	"./卡02.png": 2453,
	"./卡03.png": 2454,
	"./卡04.png": 2455,
	"./卡05.png": 2456,
	"./宿舍01.png": 2457,
	"./宿舍02.png": 2458,
	"./宿舍03.png": 2459,
	"./宿舍04.png": 2460,
	"./宿舍05.png": 2461,
	"./打印01.png": 2462,
	"./打印02.png": 2463,
	"./打印03.png": 2464,
	"./打印04.png": 2465,
	"./打印05.png": 2466,
	"./报到01.png": 2467,
	"./报到02.png": 2468,
	"./报到03.png": 2469,
	"./报到04.png": 2470,
	"./报到05.png": 2471,
	"./校服01.png": 2472,
	"./校服02.png": 2473,
	"./校服03.png": 2474,
	"./校服04.png": 2475,
	"./校服05.png": 2476,
	"./缴费01.png": 2477,
	"./缴费02.png": 2478,
	"./缴费03.png": 2479,
	"./缴费04.png": 2480,
	"./缴费05.png": 2481,
	"./通道01.png": 2482,
	"./通道02.png": 2483,
	"./通道03.png": 2484,
	"./通道04.png": 2485,
	"./通道05.png": 2486
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2578;


//////////////////
// WEBPACK FOOTER
// ./styles/images/user/grey (\.gif|\.jpeg|\.png|\.jpg|\.bmp)
// module id = 2578
// module chunks = 0